import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito experiencia en ventas o marketing?',
    answer: "¡Para nada! El método está diseñado desde cero. Te damos el 'Script de Oro' que te dice exactamente qué decir. Solo tienes que leer y tener empatía."
  }, {
    question: '¿Necesito hablar inglés perfecto?',
    answer: 'No. Este método se enfoca en el mercado hispano en EE.UU., que es gigante y está desatendido. Tu español es tu mayor activo aquí.'
  }, {
    question: '¿Cuánto tiempo necesito dedicarle al día?',
    answer: 'Tú pones tus horarios. Muchas de nuestras alumnas empiezan con 1-2 horas al día mientras mantienen sus trabajos actuales, hasta que sus comisiones superan su sueldo.'
  }, {
    question: '¿Es esto un esquema piramidal o MLM?',
    answer: 'Absolutamente NO. No tienes que reclutar a nadie, ni comprar inventario, ni molestar a tus amigos. Es un trabajo real de cerrar ventas para empresas reales.'
  }, {
    question: '¿Qué pasa después de que pago los $6.36?',
    answer: "Recibirás un correo electrónico inmediatamente con el enlace de descarga de tu PDF 'ESCAPE 9-A-5' y todos los bonos. Puedes empezar a leerlo en 2 minutos."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-light" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-12" data-id="element-14">
          <HelpCircle className="w-10 h-10 text-brand-primary mx-auto mb-4 opacity-50" data-id="element-15" />
          <h2 className="text-3xl md:text-4xl font-heading font-medium text-brand-dark mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <p className="text-brand-muted" data-id="element-17">
            Todo lo que necesitas saber antes de dar el paso.
          </p>
        </div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-rose-100 overflow-hidden transition-all duration-300 hover:shadow-md" data-id="element-19">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-20">
                <span className="font-bold text-brand-dark text-lg" data-id="element-21">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-primary" data-id="element-22" /> : <ChevronDown className="w-5 h-5 text-brand-muted" data-id="element-23" />}
              </button>

              <div className={`px-6 text-brand-muted leading-relaxed overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-24">
                {faq.answer}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}